import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeEntity: localStorage.getItem("OTC_V2_ACTIVE_ENTITY") || "",
  activeSidebarItem: localStorage.getItem("OTC_V2_ACTIVE_SIDEBAR_ITEM") || "",
};

const activeEntitySlice = createSlice({
  name: "activeEntity",
  initialState,
  reducers: {
    setActiveEntity(state, action) {
      const value = typeof action.payload === "string" ? action.payload : "";
      state.activeEntity = value;
      localStorage.setItem("OTC_V2_ACTIVE_ENTITY", value);
    },
    clearActiveEntity(state) {
      state.activeEntity = "";
      localStorage.removeItem("OTC_V2_ACTIVE_ENTITY");
    },
    setActiveSidebarItem(state, action) {
      const value = typeof action.payload === "string" ? action.payload : "";
      state.activeSidebarItem = value;
      localStorage.setItem("OTC_V2_ACTIVE_SIDEBAR_ITEM", value);
    },
    clearActiveSidebarItem(state) {
      state.activeSidebarItem = "";
      localStorage.removeItem("OTC_V2_ACTIVE_SIDEBAR_ITEM");
    },
  },
});

export const {
  setActiveEntity,
  clearActiveEntity,
  setActiveSidebarItem,
  clearActiveSidebarItem,
} = activeEntitySlice.actions;

export const selectActiveEntity = (state) =>
  (state.activeEntity && state.activeEntity.activeEntity) || "";

export const selectActiveSidebarItem = (state) =>
  (state.activeEntity && state.activeEntity.activeSidebarItem) || "";

export default activeEntitySlice.reducer;
